import React, { ComponentProps } from 'react';
import { asFetchableBlock } from '../../_lib/BlockFetcher';
import { BlockType } from '../../types/api/ElementType';
import { DefaultView, OptionalEditView, Views } from '../../types/BlockWithViews';
import { PageToPageDefaultView } from './views/PageToPageDefaultView';
import { PageToPageEditView } from './views/PageToPageEditView';
import { useAppContext } from '../../contexts/AppContext/AppContext';
import IUrl from '../../types/IUrl';

type Footer = { embedded: { footerLink: IUrl } };
export type StructuralPageToPage = Views<
  DefaultView<PageToPageDefaultView & Footer> & OptionalEditView<PageToPageEditView & Footer>
>;

/**
 * Block to connect areaPages with other areaPages.
 */
function StructuralPageToPage({ views }: StructuralPageToPage) {
  const {
    editModeInfo: { active },
  } = useAppContext();

  if (views.edit && active) {
    return <PageToPageEditView {...views.edit} />;
  }

  return <PageToPageDefaultView {...views.default} />;
}

export const StructuralPageToPageBlock = asFetchableBlock(StructuralPageToPage, BlockType.structuralPageToPage);
export type StructuralPageToPageBlock = ComponentProps<typeof StructuralPageToPageBlock>;
